const destinations = [
  {
    name: "Caribbean & Bahamas (via NOLA Port)",
    context: "New Orleans cruise departures for Northshore families — Cozumel, Grand Cayman, Nassau, Ocho Rios",
    urgency: "Last-minute cruise bookings create 2–4 week passport urgency windows for Northshore families",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Mexico (Cancun, Mexico City)",
    context: "Spring break vacations, business meetings, resort trips — Northshore families and professionals",
    urgency: "Spring break bookings often occur 4–6 weeks before travel with passport urgencies discovered late",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "United Kingdom (London, Edinburgh)",
    context: "New Orleans business executives with London connections, legal and energy sector travel",
    urgency: "Last-minute business trip invitations often arrive 7–14 days before departure",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "France (Paris, Lyon)",
    context: "Heritage tourism, culinary travel, Tulane and LSU study-abroad programs to France",
    urgency: "Study-abroad program orientations have fixed dates that standard processing can't accommodate",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Canada (Toronto, Vancouver)",
    context: "Business travel, family visits, summer vacation road trips, NHL playoff trips",
    urgency: "Cross-border travel requires a valid passport — many Northshore residents discover this late",
    icon: "ri-map-pin-2-line",
  },
  {
    name: "Italy & Mediterranean Cruises",
    context: "Retirement travel, anniversary trips, Mediterranean cruises departing from Barcelona, Rome, Athens",
    urgency: "Repositioning cruises and last-minute sailings create compressed booking timelines",
    icon: "ri-map-pin-2-line",
  },
];

const stats = [
  { stat: "35 mi", label: "distance from Slidell to Port of New Orleans — making NOLA one of the closest cruise ports for Northshore families" },
  { stat: "55%", label: "of Slidell expedited passport requests are cruise-related or leisure travel with <30 day lead time" },
  { stat: "2–3 Wks", label: "average notice Northshore travelers have when a passport urgency is discovered after booking" },
  { stat: "Dec–Feb", label: "peak season — holiday cruises, Mardi Gras sailings, and spring break bookings all collide" },
];

export default function SlidellDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Slidell Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Northshore clients. Understanding local travel behavior is part of why our document review catches issues before they derail your cruise or business trip.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same expedited passport processing expertise. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "New Orleans", href: "/cities/new-orleans" },
                { name: "Baton Rouge", href: "/cities/baton-rouge" },
                { name: "Lafayette", href: "/cities/lafayette" },
                { name: "Monroe", href: "/cities/monroe" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}